import { AxiosError } from "axios";

/**
 * The human-readable message out of a VPN debugger error response.
 *
 * The endpoints answer in two shapes: `{"error": "..."}` for the view's own
 * refusals — including the one worth surfacing verbatim, "WireGuard server has
 * no ec2_instance_id; set it on the server row (<name>) for SSM targeting" — and
 * DRF's `{"<field>": ["..."]}` for serializer validation, which is how target
 * containment failures arrive.
 */
export const extractVpnDebugApiError = (
  reason: AxiosError,
  fallback: string
): string => {
  const data = reason.response?.data as
    | Record<string, unknown>
    | string
    | undefined;

  if (typeof data === "string" && data.trim() !== "") {
    return data;
  }
  if (!data || typeof data !== "object") {
    return fallback;
  }
  if (typeof data.error === "string" && data.error.trim() !== "") {
    return data.error;
  }

  // DRF field errors: take the first message we can find, prefixed with its
  // field unless it is the catch-all.
  for (const [field, value] of Object.entries(data)) {
    const message = Array.isArray(value) ? value[0] : value;
    if (typeof message === "string" && message.trim() !== "") {
      return field === "non_field_errors" ? message : `${field}: ${message}`;
    }
  }
  return fallback;
};
